const apiUrl = process.env.VUE_APP_API_SERVER;

export const settings = {
  siteName: process.env.VUE_APP_API_SERVER
};

class URL {
  constructor(base) {
    this.base = base;
  }

  path(path, args = null) {
    path = path.split(".");
    let obj = this,
      url = this.base;

    for (let i = 0; i < path.length && obj; i++) {
      if (obj.url) {
        url += "/" + obj.url;
      }

      obj = obj[path[i]];
    }
    if (obj) {
      url = url + "/" + (typeof obj === "string" ? obj : obj.url);
    }

    if (args) {
      for (let key in args) {
        url = url.replace(":" + key, args[key]);
      }
    }

    return url;
  }
}

export const api = Object.assign(new URL(apiUrl), {
  url: "",

  logout: "api/auth/logout",
  csrf: "api/auth/csrf-cookie",
  verify: "api/auth/verify",
  register: "api/auth/registration/:referral",
  login: "api/auth/login",
  googleAuth: "api/auth/google",
  forgotPassword: "api/auth/forgot-password",
  resetPassword: "api/auth/reset-password/:token",
  verifyResetPassword: "api/auth/reset-password/:token",

  phpMyAdmin: {
    show: "api/v1/phpMyAdmin/:contractId/:customerId/:databaseId",
  },
  password: {
    url: "password",
    forgot: "email",
    reset: "reset"
  },
  broadcasting: {
    auth: "api/broadcasting/auth"
  },
  user: {
    index: "api/v1/user",
    search: "api/v1/user/search",
    updateProfile: "api/v1/user/info",
    updateSettings: "api/v1/user/settings",
    updateNotifications: "api/v1/user/notifications",
    changePassword: "api/v1/user/change-password",
    remove: "api/v1/user/delete",
    setDefaultContract: "api/user/default-contract",
    getDefaultContract: "api/user/default-contract",
    checkDelete: "api/user/check-delete",
  },
  mcpToken: {
    index: "api/v1/user/mcp-tokens",
    store: "api/v1/user/mcp-tokens",
    remove: "api/v1/user/mcp-tokens/:tokenId"
  },
  userBroadcast: {
    index: "api/v1/user/broadcasts",
    update: "api/v1/user/broadcasts"
  },
  userHistory: {
    index: "api/v1/user/histories"
  },
  userSettingsNotificationCounterparty: {
    index: "api/v1/user/setting/notification/counterparty",
    update: "api/v1/user/setting/notification/counterparty"
  },
  userSettingsNotificationContract: {
    index: "api/v1/user/setting/notification/contract",
    update: "api/v1/user/setting/notification/contract"
  },
  userSettingsNotification: {
    index: "api/v1/user/setting/notification",
    update: "api/v1/user/setting/notification"
  },
  userSettingLayout: {
    index: "api/v1/user/setting/layout/:typeId",
    update: "api/v1/user/setting/layout/:typeId"
  },
  userReferral: {
    index: "api/v1/user/referrals"
  },
  userReferralProgram: {
    index: "api/v1/user/referral-program"
  },
  userReferralCounterparty: {
    index: "api/v1/user/referrals/counterparties"
  },
  userReferralWithdrawal: {
    index: "api/v1/user/referral/withdrawals",
    store: "api/v1/user/referral/withdrawal"
  },
  other: {
    timezones: "api/v1/timezones",
    countries: "api/v1/countries"
  },
  counterparty: {
    store: "api/v1/counterparty",
    delete: "api/v1/counterparty/:counterpartyId",
    update: "api/v1/counterparty/:counterpartyId",
    index: "api/v1/counterparties",
    show: "api/v1/counterparty/:counterpartyId",
    userInvitation: "api/v1/counterparty/:counterpartyId/user-invitation"
  },
  counterpartyInvitation: {
    store: "api/v1/counterparty/:counterpartyId/user-invitation",
    remove: "api/v1/counterparty/:counterpartyId/user-invitation/:userId",
    update: "api/v1/counterparty/:counterpartyId/user-invitation/:userId"
  },
  invitationCounterparty: {
    index: "api/v1/counterparty/:userId/user-invitation",
    confirm:
      "api/v1/counterparty/:counterpartyId/user-invitation/:userId/confirm",
    unConfirm:
      "api/v1/counterparty/:counterpartyId/user-invitation/:userId/un-confirm"
  },
  counterpartyHistory: {
    index: "api/v1/counterparty/histories"
  },

  contractInvitation: {
    store: "api/v1/contract/:contractId/user-invitation",
    remove: "api/v1/contract/:contractId/user-invitation/:userId",
    update: "api/v1/contract/:contractId/user-invitation/:userId"
  },

  invitationContract: {
    index: "api/v1/contract/:userId/user-invitation",
    confirm: "api/v1/contract/:contractId/user-invitation/:userId/confirm",
    unConfirm: "api/v1/contract/:contractId/user-invitation/:userId/un-confirm"
  },

  contract: {
    store: "api/v1/contracts",
    update: "api/v1/contracts/:id",
    delete: "api/v1/contracts/:id",
    index: "api/v1/contracts",
    turnOff: "api/v1/contracts/:id/turn-off",
    turnOn: "api/v1/contracts/:id/turn-on",
    balance: "api/v1/contracts/balance",
    show: "api/v1/contracts/:id",
  },
  contractUser: {
    store: "api/v1/contract/:contractId/user",
    delete: "api/v1/contract/:contractId/user/:userId",
    update: "api/v1/contract/:contractId/user/:userId"
  },
  contractCustomer: {
    index: "api/v1/contract/:contractId/customers",
    show: "api/v1/contract/:contractId/customers/:customerId",
    store: "api/v1/contract/:contractId/customers",
    delete: "api/v1/contract/:contractId/customers/:customerId",
    update: "api/v1/contract/:contractId/customers/:customerId",
    turnOff: "api/v1/contract/:contractId/customers/:customerId/turn-off",
    turnOn: "api/v1/contract/:contractId/customers/:customerId/turn-on"
  },
  contractCustomerDatabase: {
    index: "api/v1/contract/:contractId/customers-databases",
    show: "api/v1/contract/:contractId/customers-databases/:customerDatabaseId",
    store: "api/v1/contract/:contractId/customers-databases",
    delete:
      "api/v1/contract/:contractId/customers-databases/:customerDatabaseId",
    update:
      "api/v1/contract/:contractId/customers-databases/:customerDatabaseId",
    turnOff:
      "api/v1/contract/:contractId/customers-databases/:customerDatabaseId/turn-off",
    turnOn:
      "api/v1/contract/:contractId/customers-databases/:customerDatabaseId/turn-on"
  },
  contractStorage: {
    index: "api/v1/contract/:contractId/storages",
    store: "api/v1/contract/:contractId/storages",
    remove: "api/v1/contract/:contractId/storages/:storageId",
    show: "api/v1/contract/:contractId/storages/:storageId",
    checkRemove: "api/storages/check-destroy",
    update: "api/v1/contract/:contractId/storages/:storageId",
    turnOff: "api/v1/contract/:contractId/storages/:storageId/turn-off",
    turnOn: "api/v1/contract/:contractId/storages/:storageId/turn-on",
    metricsList: "api/v1/contract/:contractId/storages/metrics",
    metricsShow: "api/v1/contract/:contractId/storages/metrics/:storageId",
    backupsShow: "api/v1/contract/:contractId/storages/backups/:storageId",
    usedShow: "api/v1/contract/:contractId/storages/used/:storageId"
  },
  contractFileManager: {
    show: "api/contract/:contractId/files-manager/:id",
    store: "api/contract/:contractId/files-manager",
    update: "api/contract/:contractId/files-manager/:managerId",
    prolong: "api/contract/:contractId/files-manager/:id/prolong",
  },
  contractDatabase: {
    index: "api/v1/contract/:contractId/databases",
    store: "api/v1/contract/:contractId/databases",
    remove: "api/v1/contract/:contractId/databases/:databaseId",
    show: "api/v1/contract/:contractId/databases/:databaseId",
    checkRemove: "api/storage/check-destroy",
    update: "api/v1/contract/:contractId/databases/:databaseId",
    turnOff: "api/v1/contract/:contractId/databases/:databaseId/turn-off",
    turnOn: "api/v1/contract/:contractId/databases/:databaseId/turn-on",
    metricsList: "api/v1/contract/:contractId/databases/metrics",
    metricsShow: "api/v1/contract/:contractId/databases/metrics/:databaseId",
    backupsShow: "api/v1/contract/:contractId/databases/backups/:databaseId",
    usedShow: "api/v1/contract/:contractId/databases/used/:databaseId"
  },
  contractTransaction: {
    index: "api/v1/contract/:contractId/transactions"
  },
  contractCertificate: {
    index: "api/v1/contract/:contractId/certificates",
    store: "api/v1/contract/:contractId/certificates",
    show: "api/v1/contract/:contractId/certificates/:certificateId",
    update: "api/v1/contract/:contractId/certificates/:certificateId",
    remove: "api/v1/contract/:contractId/certificates/:certificateId",
    turnOff: "api/v1/contract/:contractId/certificates/:certificateId/turn-off",
    turnOn: "api/v1/contract/:contractId/certificates/:certificateId/turn-on",
    sites: "api/v1/contract/:contractId/certificates/:certificateId/sites"
  },
  contractConfigurationLimit: {
    index: "api/v1/contract/:contractId/configuration/limits",
    update: "api/v1/contract/:contractId/configuration/limits",
  },
  counterpartyUser: {
    store: "api/v1/counterparty/:counterpartyId/user",
    update: "api/v1/counterparty/:counterpartyId/user/:userId",
    delete: "api/v1/counterparty/:counterpartyId/user/:userId"
  },
  contractBackupDatabase: {
    store: "api/v1/contract/:contractId/backups/databases",
    index: "api/v1/contract/:contractId/backups/databases",
    show: "api/v1/contract/:contractId/backups/databases/:id",
    update: "api/v1/contract/:contractId/backups/databases/:id",
    remove: "api/v1/contract/:contractId/backups/databases/:id",
    download: "api/v1/contract/:contractId/backups/databases/:id/download",
  },
  contractBackupStorage: {
    store: "api/v1/contract/:contractId/backups/storages",
    index: "api/v1/contract/:contractId/backups/storages",
    show: "api/v1/contract/:contractId/backups/storages/:backupStorageId",
    update: "api/v1/contract/:contractId/backups/storages/:backupStorageId",
    remove: "api/v1/contract/:contractId/backups/storages/:backupStorageId",
    download: "api/v1/contract/:contractId/backups/storages/:backupStorageId/download",
    turnOff:
      "api/v1/contract/:contractId/backups/storages/:backupStorageId/turn-off",
    turnOn:
      "api/v1/contract/:contractId/backups/storages/:backupStorageId/turn-on"
  },
  contractHistory: {
    index: "api/v1/contract/:contractId/histories",
    show: "api/v1/contract/:contractId/histories/:entityId",
  },
  site: {
    store: "api/v1/contract/:contractId/sites",
    createQuickMode: "api/v1/contract/:contractId/sites/quick-Mode",
    index: "api/v1/contract/:contractId/sites",
    show: "api/v1/contract/:contractId/sites/:siteId",
    update: "api/v1/contract/:contractId/sites/:siteId",
    remove: "api/v1/contract/:contractId/sites/:siteId",
    updateStatus: "api/v1/contract/:contractId/sites/update-status",
    turnOff: "api/v1/contract/:contractId/sites/:siteId/turn-off",
    turnOn: "api/v1/contract/:contractId/sites/:siteId/turn-on",
    metricsList: "api/v1/contract/:contractId/sites/metrics",
    metricsShow: "api/v1/contract/:contractId/sites/metrics/:siteId"
  },
  siteQuickMode: {
    store: "api/v1/contract/:contractId/sites-quick-mode",
    index: "api/v1/contract/:contractId/sites-quick-mode",
  },
  contractDomain: {
    index: "api/v1/contract/:contractId/domains",
    store: "api/v1/contract/:contractId/domains",
    show: "api/v1/contract/:contractId/domains/:domainId",
    update: "api/v1/contract/:contractId/domains/:domainId",
    remove: "api/v1/contract/:contractId/domains/:domainId",
    // show: "api/v1/contract/:contractId/domains/:domainId",
    turnOff: "api/v1/contract/:contractId/domains/:domainId/turn-off",
    turnOn: "api/v1/contract/:contractId/domains/:domainId/turn-on",
    // domainTypes: "api/v1/domain-types",
    // domainZonesSelect: "api/v1/domain-zones-for-select",
    // removeRecord:
    //   "api/v1/contract/:contractId/domains/:domainId/settings/:settingId",
  },
  contractDomainRecord: {
    store: "api/v1/contract/:contractId/domain/:domainId/records",
    update: "api/v1/contract/:contractId/domain/:domainId/records/:recordId",
    index: "api/v1/contract/:contractId/domain/:domainId/records",
    show: "api/v1/contract/:contractId/domain/:domainId/records/:recordId",
    remove: "api/v1/contract/:contractId/domain/:domainId/records/:recordId",
    turnOff: "api/v1/contract/:contractId/domain/:domainId/records/:recordId/turn-off",
    turnOn: "api/v1/contract/:contractId/domain/:domainId/records/:recordId/turn-on",
  },
  cron: {
    index: "api/v1/contract/:contractId/crons",
    create: "api/v1/contract/:contractId/crons",
    show: "api/v1/contract/:contractId/crons/:cronId",
    update: "api/v1/contract/:contractId/crons/:cronId",
    remove: "api/v1/contract/:contractId/crons/:cronId",
    turnOff: "api/v1/contract/:contractId/crons/:cronId/turn-off",
    turnOn: "api/v1/contract/:contractId/crons/:cronId/turn-on",
    // bellOff: "api/v1/contract/:contractId/cron/:cronId/bell-off",
    // bellOn: "api/v1/contract/:contractId/cron/:cronId/bell-on"
  },
  payment: {
    index: "api/contract/:contractId/payment",
    store: "api/contract/:contractId/payment",
    paid: "api/contract/:contractId/payment/:paymentId",
    test: "api/contract/test"
  },
  contractSpendingChart: {
    show: "api/contract/:contractId/spending-chart/:typeId"
  },
  contractSpendingTotal: {
    show: "api/contract/:contractId/spending-total",
    showByDate: "api/contract/:contractId/spending-total/:date"
  },
  contractSpendingMonthly: {
    index: "api/contract/:contractId/spending-monthly"
  },
  contractEntitySpend: {
    index: "api/contract/entity-spend/:contractId/:periodId"
  },
  contractBalance: {
    index: "api/v1/contract/:contractId/balance",
    show: "api/v1/contracts/balance/:id"
  },
  contractBalanceReplenishmentHistory: {
    index: "api/v1/contract/:contractId/balance/replenishment"
  },
  contractBalanceOverview: {
    index: "api/contract/:contractId/balance-overview"
  },
  contractBalanceOperationHistory: {
    index: "api/contract/:contractId/balance-operation-history"
  },
  contractSetting: {
    show: "api/v1/contract/:contractId/settings",
    update: "api/v1/contract/:contractId/settings"
  },
  invoice: {
    pdf: "api/v1/contract/:contractId/invoice/:id/pdf"
  },
  contractProcessorPhpCustom: {
    index: "api/v1/contract/:contractId/processors-php",
    show: "api/v1/contract/:contractId/processors-php/:id",
    store: "api/v1/contract/:contractId/processors-php",
    update: "api/v1/contract/:contractId/processors-php/:id",
    delete: "api/v1/contract/:contractId/processors-php/:id"
  },

  contractConfigPhpIni: {
    index: "api/v1/config/contract/php-ini",
    show: "api/v1/config/contract/php-ini/:typeId"
  },
  contractConfigPhpIni: {
    index: "api/v1/config/contract/php-ini",
    show: "api/v1/config/contract/php-ini/:typeId"
  },

  //TODO новый подход, поместить внутрь contract ключа.
  contractDashboardContractMap: {
    index: "api/contract/:contractId/backup/contract-map"
  },
  contractMetric: {
    grafana_index: "api/v1/contract/:contractId/metric/grafana"
  },
  support: {
    tickets: "api/v1/support/tickets",
    ticket: "api/v1/support/tickets/:ticketId"
  },
  backup: {
    databasePlan: {
      index: "api/v1/contract/:contractId/backup/database-plan",
      store: "api/v1/contract/:contractId/backup/database-plan",
      show: "api/v1/contract/:contractId/backup/database-plan/:id",
      remove: "api/v1/contract/:contractId/backup/database-plan/:id",
      update:
        "api/v1/contract/:contractId/backup/database-plan/:id",
      turnOff:
        "api/v1/contract/:contractId/backup/database-plan/:id/turn-off",
      turnOn:
        "api/v1/contract/:contractId/backup/database-plan/:id/turn-on"
    },
    storagePlan: {
      index: "api/v1/contract/:contractId/backup/storage-plan",
      store: "api/v1/contract/:contractId/backup/storage-plan",
      show: "api/v1/contract/:contractId/backup/storage-plan/:id",
      update: "api/v1/contract/:contractId/backup/storage-plan/:id",
      remove: "api/v1/contract/:contractId/backup/storage-plan/:id",
      turnOff:
        "api/v1/contract/:contractId/backup/storage-plan/:id/turn-off",
      turnOn:
        "api/v1/contract/:contractId/backup/storage-plan/:id/turn-on"
    }
  }
});
